// Stylesheets
import './assets/scss/site.scss';

import {fixSvgIntrinsicSizing} from './assets/modules/fixSvgIntrinsicSizing';
import {hover} from './assets/modules/hover';
import {lazyload} from './assets/modules/lazyload';
import {pageTop} from './assets/modules/pageTop';
import {headerShowHide} from './assets/modules/headerShowHide';
import {nav} from './assets/modules/nav';
import {scrollNav} from './assets/modules/scrollNav';
import {stickyNav} from './assets/modules/stickyNav';
import {ytInit} from './assets/modules/ytInit';
import {popupYouTube} from './assets/modules/popupYouTube';
import {initPhotoSwipeFromDOM} from './assets/modules/photoswipe-init';
import {carousel} from './assets/modules/carousel';


fixSvgIntrinsicSizing();
hover();
lazyload();
pageTop();
headerShowHide();
nav();
scrollNav();
stickyNav();
ytInit();
popupYouTube();
initPhotoSwipeFromDOM('.js-pswp-container');
carousel();